// Copyright (c) 2016 Deere & Company

import KeyValuePair, {getDefaultState as getKeyValueDefaultState} from './key-value-pair';
import t from 'tcomb';

const ClaimSpecialAllowanceCalculation = t.struct({
    companyContribution: t.maybe(t.Number),
    contributionTotal: t.Number,
    creditMemoNumber: t.String,
    currency: KeyValuePair,
    customerContribution: t.maybe(t.Number),
    dealerContribution: t.maybe(t.Number),
    exchangeRate: t.Number,
    localCurrency: KeyValuePair,
    systemAllowed: t.Number,
    tax: t.Number,
    taxInLocalCurrency: t.Number,
    totalAmountInLocalCurrency: t.Number,
    totalAmountReimbursed: t.Number,
    totalAmountReimbursedInLocalCurrency: t.Number
}, {
    name: 'ClaimSpecialAllowanceCalculation',
    strict: true
});

export const getDefaultState = () => new ClaimSpecialAllowanceCalculation({
    companyContribution: null,
    contributionTotal: 0,
    creditMemoNumber: '',
    currency: getKeyValueDefaultState(),
    customerContribution: null,
    dealerContribution: null,
    exchangeRate: 0,
    localCurrency: getKeyValueDefaultState(),
    systemAllowed: 0,
    tax: 0,
    taxInLocalCurrency: 0,
    totalAmountInLocalCurrency: 0,
    totalAmountReimbursed: 0,
    totalAmountReimbursedInLocalCurrency: 0
});

export default ClaimSpecialAllowanceCalculation;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-special-allowance-calculation.js